import React, { useEffect, useState } from 'react';

//import {Fade} from "react-awesome-reveal"
import fileDownload from 'js-file-download'

import '../../styles/pacientesPendientes.css'
import '../../styles/tarjetaContenedor.css'

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';

const CredentialViewer = ({cantidadPacientes,paciente,setIsMostrarCredencial}) => {

    const [url,setUrl] = useState("")
    const [urlDos,setUrlDos] = useState("")
    const [isHover,setIsHover] = useState(false)
    const [isAnverso, setIsAnverso] = useState(true)
    const [blobAnverso, setBlobAnverso] = useState("")
    const [blobReverso, setBlobReverso] = useState("")
    const [isLoader,setIsLoader] = useState(false)

    useEffect(()=>{
        if(paciente){
            setIsLoader(true)
            let gender = ""
            if(paciente.gender === "1"){
                gender = ""
            }
            else{
                gender = ""
            }
            let jsonFront = {
                apikey : process.env.REACT_APP_KEY,
                Name : gender+" "+paciente.name,
                LastName : paciente.lastname,
                Specialist : paciente.specialty.toUpperCase(),
                Tenant : paciente.hospital,
                ID : paciente.identificador,
                image : paciente.basefotografia.split('data:image/png;base64,')[1]
              }

            if(paciente.hospital === "MAC Perisur"){
                jsonFront.Tenant = "CDMX Periférico Sur"
            }
            console.log(jsonFront)
            
            fetch(process.env.REACT_APP_BADGE_FRONT,
            {
                method: "POST",
                mode:'cors',
                body: JSON.stringify(jsonFront)
            })
            .then(function(response) {
                if(response.ok) {
                  response.blob().then(function(miBlob) {
                    setBlobAnverso(miBlob)
                    var objectURL = URL.createObjectURL(miBlob);
                    setUrl(objectURL)
                    setTimeout(() => {
                        setIsLoader(false)
                      }, "1000");
                  });
                } else {
                  //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                }
              })
              .catch(function(error) {
                //console.log('Hubo un problema con la petición Fetch:' + error.message);
              });

            let jsonBack = {
                "apikey":process.env.REACT_APP_KEY,  
                "Specialist1":paciente.specialty_array[0], 
                "Specialist1ID":paciente.cedula_array[0],
                "Specialist2":paciente.specialty_array[1],
                "Specialist2ID":paciente.cedula_array[1],
                "Specialist3":paciente.specialty_array[2],
                "Specialist3ID":paciente.cedula_array[2],
                "QR":"https://smvigencia.hospitalesmac.com/badge/" + paciente.identificador
                }

                fetch(process.env.REACT_APP_BADGE_BACK,
                {
                    method: "POST",
                    mode:'cors',
                    body: JSON.stringify(jsonBack)
                })
                .then(function(response) {
                    if(response.ok) {
                      response.blob().then(function(miBlob) {
                        setBlobReverso(miBlob)
                        var objectURL = URL.createObjectURL(miBlob);
                        setUrlDos(objectURL)
                        
                      });
                    } else {
                      //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                    }
                  })
                  .catch(function(error) {
                    //console.log('Hubo un problema con la petición Fetch:' + error.message);
                  });
        }
    },[paciente])

    const handleAgregar = () => (event) => {
        event.preventDefault()
        setIsMostrarCredencial(false)
    }

    const handleDescargar = () => (event) => {
        event.preventDefault()
        if(isAnverso){
            fileDownload(blobAnverso,"CredencialAnverso-"+paciente.identificador+".png")
        }
        else{
            fileDownload(blobReverso,"CredencialReverso-"+paciente.identificador+".png")
        }
    }

    const handleMostrar = () => (event) => {
        event.preventDefault()
        setIsHover(true)
        //setTimeout(() => btn.classList.add('animate'), 100)
        setTimeout(() => {
            setIsAnverso(!isAnverso)
            setIsHover(false)
          }, "1000");
    }

    return(
        <>
        <section className='seccion_pacientes_pendientes'>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                <button className="btn-flotante" title="Agregar credencial" alt="Agregar" onClick={handleAgregar()}>X Regresar</button>
                <EncabezadoSeccion tituloInicial={"Credencial"} tituloFinal={paciente.identificador +" "+paciente.name} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
            </div>
            <div className='itemservespCont'>
                <div className={"itemCredential"}>
                    {/* <iframe
                        src={url}
                        //src='https://apibot.hospitalesmac.app/public/labels/asdfsdf/345345354adfgd/a345345345/sdgdsfsdfsdfa/a43543534543/5fe72104fac6af0fa95dbbb0e910fde7'
                        height={"300px"} 
                        width={"400px"}
                        key={paciente.id}
                        title={paciente.name}
                    /> */}
                    {/* <br></br>
                    <br></br> */}
                    {/* <iframe
                        src={urlDos}
                        //src='https://apibot.hospitalesmac.app/public/labels/asdfsdf/345345354adfgd/a345345345/sdgdsfsdfsdfa/a43543534543/5fe72104fac6af0fa95dbbb0e910fde7'
                        height={"300px"} 
                        width={"400px"}
                        key={paciente.name}
                        title={paciente.name}
                    /> */}
                    {
                        !isLoader
                            ?
                                <>
                                    {
                                        !isHover 
                                            ?
                                                isAnverso
                                                    ?
                                                        <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialView'  
                                                            onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                    :
                                                        <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialView' onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                            :
                                                isAnverso
                                                    ?
                                                        <img src={url} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                                    :
                                                        <img src={urlDos} width={"321.25988299px"} height={"209.76380595px"} className='credentialViewHover'  onClick={handleMostrar()} alt={paciente.identificador +" "+paciente.name}/>
                                    }
                                    <p className='boton_uno' onClick={handleDescargar()}>Descargar</p>
                                </>
                            :
                            <>
                                <h1 className='itemblogTitle'>{"Cargando Credencial"}</h1>      
                                <img src={"https://hospitalesmac.com/img/logo.png"} width={"107.25988299px"} height={"69.76380595px"} className='credentialView' alt={paciente.identificador +" "+paciente.name}/>
                            </>
                                
                    }
                </div>
            </div>
        </section>
        </>
    )
}

export default CredentialViewer;